import React from 'react';
import { HeadingProps } from 'apps/sigma2-ui/src/lib/text';
import { TextProps } from 'apps/sigma2-ui/src/lib/text';
import { Text } from 'apps/sigma2-ui/src/components/ui/Text';
import { safeTwClass } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';

const levelsToTagName: Record<HeadingProps['level'], TextProps['tagName']> = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
};

/**
 * @deprecated Use the `Typography` component instead.
 * @see Typography
 */
export const Heading: React.FC<HeadingProps> = (props) => {
  const { level, ...rest } = props;

  return (
    <Text
      {...rest}
      tagName={levelsToTagName[level]}
      fontFamily={safeTwClass({
        defaultValue: 'font-serif',
        override: props.fontFamily,
      })}
      textColor={safeTwClass({
        defaultValue: 'text-gray-900',
        override: props.textColor,
      })}
      fontWeight={safeTwClass({
        defaultValue: 'font-normal',
        override: props.fontWeight,
      })}
    />
  );
};
